export default __webpack_public_path__ + "static/media/39.0aa7cd0f.png";